import FormSwitch from "@babackapp/react-hook-forms-components/form-switch";
import { FormField } from "@babackapp/ui/components/form";
import { useFormContext } from "react-hook-form";
import { ReturnReasonFormValues } from "./add-return-reason-dialog";
import useTranslation from "@babackapp/translations/use-translation";

export default function ReturnReasonReturnRulesForm() {
  const t = useTranslation();
  const { control } = useFormContext<ReturnReasonFormValues>();

  return (
    <div className="pt-8 flex flex-col gap-8">
      <FormField
        control={control}
        name="skipReturnCost"
        render={({ field }) => (
          <FormSwitch
            label={t("settings.reasons.fields.skipReturnCost.title")}
            description={t(
              "settings.reasons.fields.skipReturnCost.description",
            )}
            value={field.value}
            onChange={field.onChange}
          />
        )}
      />

      <FormField
        control={control}
        name="skipReshipping"
        render={({ field }) => (
          <FormSwitch
            label={t("settings.reasons.fields.skipReshipping.title")}
            description={t(
              "settings.reasons.fields.skipReshipping.description"
            )}
            value={field.value}
            onChange={field.onChange}
          />
        )}
      />

      <FormField
        control={control}
        name="highlighted"
        render={({ field }) => (
          <FormSwitch
            label={t("settings.reasons.fields.highlighted.title")}
            description={t("settings.reasons.fields.highlighted.description")}
            value={field.value}
            onChange={field.onChange}
          />
        )}
      />

      <FormField
        control={control}
        name="reservedForLoggedUser"
        render={({ field }) => (
          <FormSwitch
            label={t("settings.reasons.fields.reservedForLoggedUser.title")}
            description={t(
              "settings.reasons.fields.reservedForLoggedUser.description",
            )}
            value={field.value}
            onChange={field.onChange}
          />
        )}
      />
    </div>
  );
}
